export enum QuizTypes {
    SET_CORRECT_ANSWERS_ARRAY = 'SET_CORRECT_ANSWERS_ARRAY',
    SET_USER_ANSWERS_ARRAY = 'SET_USER_ANSWERS_ARRAY',

    SET_FORM_QUESTIONS_COUNTER = 'SET_FORM_QUESTIONS_COUNTER',
    SET_FORM_ICON_NAME = 'SET_FORM_ICON_NAME',
    SET_FORM_QUESTIONS = 'SET_FORM_QUESTIONS',
    SET_FORM_CATEGORY = 'SET_FORM_CATEGORY',
    SET_FORM_COLOR = 'SET_FORM_COLOR'
}

